import React from 'react'

// Translations
import { TRANSLATIONS } from 'pages/Career/utilities';
import { getTranslation } from 'translations';

// Hooks
import useResponsiveJSX from 'hooks/useResponsiveJSX';

//* Styles
import styles from './Banner.module.scss';

const BG = "https://filotrack.com/wp-content/uploads/AboutUs_Banner_2023.webp"

const Banner = () => {
    const LANG = document.documentElement.lang.substring(0, 2).toLowerCase();
    const bp = useResponsiveJSX();

  return (
    <div className={styles["banner"]}>
        <img src={BG} alt="work-with-us-banner" className={styles['bg-img']}/>
        <div className={`${styles["content-text"]} ${bp < 3 ? styles["content-text-sm"] : styles["content-text-xl"]}`}>
            <h1 className={styles['title']}>{getTranslation(TRANSLATIONS, LANG, "banner_title")}</h1>
            <p className={styles["text"]}>{getTranslation(TRANSLATIONS, LANG, "banner_text")}</p>
        </div>
    </div>
  )
}

export default Banner